import { PRProductSupported } from '@/domains/core/tracking/interfaces/PRProductSupported';
import { RhinoProduct } from '@/domains/productDiscovery/ProductPage/interfaces/RhinoProduct';

// Rhinoproduct : no bulk, isSponsored, isSecondHand informations
interface Params {
  item: RhinoProduct;
  itemIndex: number;
  isSponsored?: boolean;
}
export const rhinoProductToPrProductMapper = ({
  item,
  itemIndex,
  isSponsored = false,
}: Params): PRProductSupported => {
  return {
    pr_article_id: item.articleId,
    pr_model_id: item.modelId,
    pr_product_id: item.productId,
    pr_seller_id: item.seller?.id,
    pr_brand_id: item.brand.id,
    pr_lowest_category_id: item.categoriesLastId || 0,
    pr_name: item.title,
    pr_price: item.price.currentPrice?.amountWithVat || 0,
    pr_price_excluding_vat: item.price.currentPrice?.amountWithoutVat || 0,
    pr_is_sponsored: isSponsored,
    pr_is_mf: item.isFulfillment,
    pr_position: itemIndex + 1,
    pr_quantity: undefined,
    pr_category_level_name_1: item.categoriesL0,
    pr_category_level_name_2: item.categoriesL1,
    pr_category_level_name_3: item.categoriesL2,
    pr_category_level_name_4: item.categoriesL3,
    pr_category_level_id_1: item.categoriesL0Id,
    pr_category_level_id_2: item.categoriesL1Id,
    pr_category_level_id_3: item.categoriesL2Id,
    pr_category_level_id_4: item.categoriesL3Id,
    pr_brand_name: item.brand.name,
    pr_has_a_coupon: !!item.coupon,
    pr_rating_count: item.rating?.totalRatings,
    pr_rating: item.rating?.average,
    pr_variant_count: item.modelsCount,
    pr_is_second_hand_product: undefined,
    pr_shipping_options: undefined,
    pr_b2b_price_advantage_count: undefined,
    pr_md_count: undefined,
    pr_is_best_quality_offer: undefined,
    pr_label: undefined,
    pr_total_ati: undefined,
  };
};
